import PropTypes from "prop-types"
import React from "react"
import { useFormContext } from "react-hook-form"

import Form from "src/components/Form"

const SeasonDateSelector = ({ prefix, monthValue, monthDays, disabled }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const seasonKey = `fuelDockAvailability.season.${prefix.toLowerCase()}`
  const months = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ]
  const dayOptions = () =>
    monthDays.map((day) => (
      <option key={day} value={day}>
        {day}
      </option>
    ))
  const monthOptions = months.map((month) => (
    <option key={month.value} value={month.value}>
      {month.label}
    </option>
  ))

  return (
    <>
      <div className="col-span-6">
        <Form.Label htmlFor={`${seasonKey}Month`}>{prefix} Month</Form.Label>
        <Form.Select
          {...register(`${seasonKey}Month`)}
          id={`${seasonKey}Month`}
          disabled={disabled}
          hasErrors={
            !!errors?.fuelDockAvailability?.season?.[
              `${prefix.toLowerCase()}Month`
            ]
          }
        >
          <option value="" disabled>
            Select Month
          </option>
          {monthOptions}
        </Form.Select>
        {errors?.fuelDockAvailability?.season?.[
          `${prefix.toLowerCase()}Month`
        ] && (
          <Form.Error>
            {
              errors.fuelDockAvailability?.season[
                `${prefix.toLowerCase()}Month`
              ].message
            }
          </Form.Error>
        )}
      </div>
      <div className="col-span-6">
        <Form.Label htmlFor={`${seasonKey}Day`}>{prefix} Day</Form.Label>
        <Form.Select
          {...register(`${seasonKey}Day`)}
          disabled={!monthValue || disabled}
          id={`${seasonKey}Day`}
          hasErrors={
            !!errors?.fuelDockAvailability?.season?.[
              `${prefix.toLowerCase()}Day`
            ]
          }
        >
          <option value="" disabled>
            Select Day
          </option>
          {dayOptions()}
        </Form.Select>
        {errors?.fuelDockAvailability?.season?.[
          `${prefix.toLowerCase()}Day`
        ] && (
          <Form.Error>
            {
              errors.fuelDockAvailability?.season[`${prefix.toLowerCase()}Day`]
                .message
            }
          </Form.Error>
        )}
      </div>
    </>
  )
}

SeasonDateSelector.propTypes = {
  prefix: PropTypes.string.isRequired,
  monthValue: PropTypes.number,
  monthDays: PropTypes.arrayOf(PropTypes.number).isRequired,
  disabled: PropTypes.bool,
}

export default SeasonDateSelector
